import { render } from "./ProductoFormView.vue?vue&type=template&id=298369d0&ts=true"
import script from "./ProductoFormView.vue?vue&type=script&lang=ts"
export * from "./ProductoFormView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__